// The pinned GoPhish editor runs in an opaque-origin sandbox. The matching
// divarea plugin avoids nested iframe origin restrictions; this adapter keeps
// the full document envelope available in Source mode and across visual edits.
export function ckeditorFrameDocument(basePath, channel, parentOrigin) {
  const config = JSON.stringify({ basePath, channel, parentOrigin }).replace(/</g, '\\u003c');
  return `<!doctype html><html><head><meta charset="utf-8"><style>html,body{margin:0;padding:0;background:#fff}textarea{width:100%}</style></head><body><textarea id="editor"></textarea>
<script>
(function () {
  var config = ${config}, editor, applying = false, touched = false, fullDocument = '';
  var templateStyles = document.createElement('div');
  document.body.appendChild(templateStyles);
  function send(type, values) {
    parent.postMessage(Object.assign({channel:config.channel,type:type},values||{}),config.parentOrigin);
  }
  window.addEventListener('error',function(event){send('error',{message:event.message});});
  function resize() {
    if (editor && editor.container) send('resize',{height:editor.container.$.offsetHeight+12});
  }
  function change() {
    if (applying || !touched) return;
    var content = editor.mode === 'source' ? editor.editable().$.value : editor.getData();
    if (editor.mode === 'source') fullDocument = content;
    else if (/<(?:html|head|body)\\b|<!doctype\\b/i.test(fullDocument)) {
      var parsed = new DOMParser().parseFromString(fullDocument,'text/html');
      parsed.body.innerHTML = content;
      var doctype = fullDocument.match(/<!doctype[^>]*>/i);
      fullDocument = (doctype ? doctype[0] : '<!DOCTYPE html>')+'\\n'+parsed.documentElement.outerHTML;
    } else fullDocument = content;
    send('change',{html:fullDocument,mode:editor.mode});
  }
  function bindInput() {
    var editable = editor.editable();
    if (!editable) return;
    editable.on('keydown',function(){touched=true;});
    editable.on('input',function(){touched=true;change();});
    editable.on('paste',function(){touched=true;});
  }
  function load() {
    applying = true; touched = false;
    var parsed = new DOMParser().parseFromString(fullDocument,'text/html');
    var base = parsed.querySelector('base[href]');
    var sourceBase = base ? base.getAttribute('href') : config.parentOrigin;
    templateStyles.innerHTML = '';
    parsed.head.querySelectorAll('style,link[rel="stylesheet"]').forEach(function(node){
      var copy = node.cloneNode(true);
      Array.from(copy.attributes).forEach(function(attribute){if(/^on/i.test(attribute.name))copy.removeAttribute(attribute.name);});
      if (copy.hasAttribute('href')) {
        try { copy.setAttribute('href',new URL(copy.getAttribute('href'),sourceBase).href); } catch (_) {}
      }
      templateStyles.appendChild(copy);
    });
    if (base) parsed.body.querySelectorAll('[src],[href]').forEach(function(node){
      ['src','href'].forEach(function(attribute){
        var value = node.getAttribute(attribute);
        if(value && value.indexOf('{{')===-1)try{node.setAttribute(attribute,new URL(value,sourceBase).href);}catch(_){}
      });
    });
    var content = editor.mode === 'source' ? fullDocument : parsed.body.innerHTML;
    editor.setData(content,function(){applying=false;touched=false;editor.resetDirty();resize();});
  }
  window.addEventListener('message',function(event){
    if (event.source!==parent || !event.data || event.data.channel!==config.channel) return;
    if (event.data.type==='load' && editor) {fullDocument=event.data.html;load();}
  });
  window.CKEDITOR_BASEPATH=config.basePath;
  var script=document.createElement('script');
  script.src=config.basePath+'ckeditor.js';
  script.onerror=function(){send('error');};
  script.onload=function(){
    editor=CKEDITOR.replace('editor',{
      customConfig:config.basePath+'config.js',extraPlugins:'divarea',
      fullPage:false,allowedContent:true,startupMode:'wysiwyg',height:360,
      resize_enabled:true,baseFloatZIndex:1100
    });
    editor.on('instanceReady',function(){bindInput();send('ready');resize();});
    editor.on('contentDom',bindInput);
    editor.on('mode',function(){bindInput();if(fullDocument)setTimeout(load,0);});
    editor.on('change',change);
    editor.on('beforeCommandExec',function(event){
      if(event.data.name==='source'){
        if(editor.mode==='source'){
          fullDocument=editor.editable().$.value;
          send('change',{html:fullDocument,mode:'source'});
        }
        applying=true;touched=false;
      }
      else touched=true;
    });
    editor.on('paste',function(){touched=true;});
    editor.on('resize',resize);
    editor.on('dialogShow',function(){send('resize',{height:650});});
    editor.on('dialogHide',resize);
  };
  document.head.appendChild(script);
}());
</script></body></html>`;
}
